<div class="list-questions__container">
  <div class="list-questions__container__header">
    <div class="list-questions__container__header-title">
      <span class="fs__lg fw__500">Questions</span>
      @if (count$() > 0) {
        <span class="counter fs__sm fw__500">{{ count$() }} items</span>
      }
      <eiq-button [text]="selectMode$() ? 'Done' : 'Select'" [style]="'basic'" [color]="'light'" (clicked)="onToggleSelectMode()"></eiq-button>
    </div>

    @if (selectMode$()) {
      <div class="list-questions__container__header__select">
        <mat-checkbox
          color="primary"
          [checked]="selectedQuestions$().size === questions$().length"
          [indeterminate]="selectedQuestions$().size > 0 && selectedQuestions$().size < questions$().length"
          [labelPosition]="'after'"
          (change)="onSelectAll($event.checked)"
        >
          <span class="fs__sm fw__500">Select all</span>
        </mat-checkbox>

        <span class="fs__sm fw__500">{{ selectedQuestions$().size }}/{{ questions$().length }} Selected</span>
      </div>
    }
  </div>

  <div class="list-questions__list" [class.selecting]="selectMode$()" empathyInfiniteScroll (loadMore)="onLoadMore()">
    <mat-action-list>
      @if (variableQuestions$().length > 0) {
        <mat-expansion-panel class="list-questions__variables">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Source Variables <span class="fs__sm">({{ variableQuestions$().length }})</span>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="list-questions__variables-list">
            @for (question of variableQuestions$(); track question.id; let index = $index) {
              <empathy-list-variable-item [question]="question" (activate)="onActivateVariable($event)"></empathy-list-variable-item>
            }
          </div>
        </mat-expansion-panel>
      }

      @if (loading$()) {
        <div class="list-questions__list__loading">
          <mat-spinner diameter="20" color="light"></mat-spinner>
          <span class="fs__sm fw__600">Loading questions...</span>
        </div>
      } @else {
        <div class="list-questions__rows">
          @for (row of visibleRows$(); track row.id) {
            <div class="list-questions__virtual-row" [class.is-page]="row.type === 'pageBreak'" [id]="'list-questions-row-' + row.id">
              @switch (row.type) {
                @case ('welcome') {
                  <empathy-list-welcome-item></empathy-list-welcome-item>
                }
                @case ('pageBreak') {
                  <div class="list-questions__page-break">
                    <button
                      mat-icon-button
                      matTooltip="Delete Page"
                      [attr.data-testid]="'list-questions-delete-page-' + row.pageId + '-button'"
                      (click)="onRemovePage(row.pageId)"
                    >
                      <fa-icon [icon]="faClose"></fa-icon>
                    </button>
                    <mat-divider></mat-divider>
                  </div>
                }
                @case ('block') {
                  <empathy-list-block-questions-item
                    [blockView]="row.blockView"
                    [activeQuestionId]="activeQuestionId$()"
                    (activate)="onActivate($event)"
                    (removePage)="onRemovePage($event)"
                  />
                }
                @case ('question') {
                  <div class="list-questions__list-row">
                    <empathy-list-question-item
                      [id]="'anchor__' + row.question.id"
                      [active]="activeQuestionId$() === row.question.id"
                      [isFirst]="row.isFirst"
                      [isLast]="row.isLast"
                      [movePositionAllowed]="row.movePositionAllowed"
                      [question]="row.question"
                      (activate)="onActivate($event)"
                    ></empathy-list-question-item>
                  </div>
                }
                @case ('end') {
                  <empathy-list-end-page-item></empathy-list-end-page-item>
                }
              }
            </div>
          }
        </div>
      }
    </mat-action-list>
  </div>

  <div class="list-questions__container__footer">
    @if (selectMode$()) {
      <div class="list-questions__container__footer__select">
        <div class="list-questions__container__footer__select__info">
          <span class="fs__sm fw__500">
            {{
              selectedQuestions$().size > 0
                ? selectedQuestions$().size + (selectedQuestions$().size === 1 ? ' Item' : ' Items') + ' selected'
                : 'No item selected'
            }}
          </span>
          <div class="list-questions__container__footer__select__info-clear fs__sm fw__500" (click)="onClearSelectedQuestions()">Clear</div>
        </div>
        <div class="list-questions__container__footer__select__actions">
          <div class="list-questions__container__footer__select__actions-row">
            <button
              mat-stroked-button
              color="primary"
              title="Move"
              data-testid="list-questions-bulk-move-button"
              [disabled]="!selectedQuestions$()?.size"
              (click)="moveQuestions.emit()"
            >
              <fa-icon [icon]="faArrowRight"></fa-icon>
              <span class="fs__md fw__600">Move</span>
            </button>

            <button
              mat-stroked-button
              color="primary"
              title="Duplicate"
              data-testid="list-questions-bulk-duplicate-button"
              [disabled]="!selectedQuestions$()?.size"
              (click)="duplicateQuestions.emit()"
            >
              <fa-icon [icon]="faClone"></fa-icon>
              <span class="fs__md fw__600">Duplicate</span>
            </button>
          </div>

          <button
            mat-stroked-button
            color="warn"
            title="Delete"
            data-testid="list-questions-bulk-delete-button"
            [disabled]="!selectedQuestions$()?.size"
            (click)="deleteQuestions.emit()"
          >
            <fa-icon [icon]="faTrash"></fa-icon>
            <span class="fs__md fw__600">Delete</span>
          </button>
        </div>
      </div>
    } @else {
      <button class="list-questions__container__footer__add" mat-flat-button color="primary" (click)="addQuestion.emit()">
        <fa-icon [icon]="faPlus"></fa-icon>
        Add Question
      </button>
      <button mat-stroked-button color="primary" title="Add page break" (click)="addPageBreak.emit()">
        <fa-icon [icon]="faFileDashedLine"></fa-icon>
      </button>
    }
  </div>
</div>
